var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVelmaHighlighted({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29401",
    "data-name": "Group 29401",
    transform: "translate(-555.999 -262.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(555.999 262.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_29398",
    "data-name": "Group 29398",
    transform: "translate(574.808 270.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50303",
    "data-name": "Path 50303",
    d: "M11.909,29.447s-1.206.222-1.113,2.034,3.544,5.141,6.847,5.141,2.987-2.7,2.987-2.7,2.264-2.034.167-2.885S11.909,29.447,11.909,29.447Z",
    transform: "translate(-8.235 -18.035)",
    fill: "#f57c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50304",
    "data-name": "Path 50304",
    d: "M10.208,11.843C8.037,13.773,4.2,13.68,4.2,7.687S9.763,0,11.952,0s8.294,1.3,6.587,6.717c1.874,1.67,1.149,4.344-.946,4.583C16.155,11.47,11.674,11.751,10.208,11.843Z",
    transform: "translate(-4.196 -0.005)",
    fill: "#5a2227"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50305",
    "data-name": "Path 50305",
    d: "M13.053,19.6c.165.495.631,1.429,2.56,1.206a2.628,2.628,0,0,1-1.307,1.452,7.14,7.14,0,0,0,4.927,2.03A4.606,4.606,0,0,0,23.5,20.025a2.189,2.189,0,0,0-.419-1.033,2.962,2.962,0,0,1-.443-2.26l.214-1.121a2.917,2.917,0,0,1-1.781.057,2.916,2.916,0,0,1-2.746.088,4.333,4.333,0,0,1-3.563.114c-.872,1.15-1.262,3.117.278,3.8A2.8,2.8,0,0,1,13.053,19.6Z",
    transform: "translate(-9.62 -9.562)",
    fill: "#ffcc80"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8464",
    "data-name": "Rectangle 8464",
    width: 6.977,
    height: 0.775,
    transform: "translate(4.188 7.362)",
    fill: "#039be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50306",
    "data-name": "Path 50306",
    d: "M18.931,18.625a4.574,4.574,0,0,0,.388,2.713,10.843,10.843,0,0,0,3.1,0,7.381,7.381,0,0,0,0-2.713A6.529,6.529,0,0,0,18.931,18.625Z",
    transform: "translate(-13.193 -11.263)",
    fill: "#039be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50307",
    "data-name": "Path 50307",
    d: "M31,18.625l.388,2.713A7.955,7.955,0,0,0,34.249,21a7.531,7.531,0,0,0,.239-2.379A6.532,6.532,0,0,0,31,18.625Z",
    transform: "translate(-20.611 -11.263)",
    fill: "#039be5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50308",
    "data-name": "Path 50308",
    d: "M30.144,23.8a1.855,1.855,0,0,0,.779.26c.353,0,.668.612-.241,1.373.222-.557.2-.909-.111-1.021S30.144,23.8,30.144,23.8Z",
    transform: "translate(-20.087 -14.576)",
    fill: "#efad60"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_483",
    "data-name": "Ellipse 483",
    cx: 0.388,
    cy: 0.388,
    rx: 0.388,
    ry: 0.388,
    transform: "translate(7.288 8.138)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_484",
    "data-name": "Ellipse 484",
    cx: 0.388,
    cy: 0.388,
    rx: 0.388,
    ry: 0.388,
    transform: "translate(11.552 8.138)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50309",
    "data-name": "Path 50309",
    d: "M22.628,29.08l.309-.325a.828.828,0,0,0,.99.286,4.032,4.032,0,0,1,2.322-.019c.378.123.56-.205.738-.432l.317.221c-.186.544-.705,1.16-1.376.917a3.03,3.03,0,0,0-1.778.056A1.146,1.146,0,0,1,22.628,29.08Z",
    transform: "translate(-15.484 -17.511)",
    fill: "#efad60"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVelmaHighlighted);
export default __webpack_public_path__ + "static/media/velmaHighlighted.1b0696a77ec0befea756fb1bc3a9c22f.svg";
export { ForwardRef as ReactComponent };